import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Sidebar',
  computed: {
    ...mapGetters([
      'workspaces',
      'contentplans',
      'activeWorkspace',
      'activeContentplan'
    ]),
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    },
    contentplanId () {
      return parseInt(this.$route.params.contentplanId)
    },
    unusedContentplans () {
      if (this.workspaces && this.contentplans) {
        return this.workspaces.find(w => w.id === this.workspaceId).paid_plans - this.contentplans.length + 1
      }
    },
    selectableWorkspaces () {
      if (!this.workspaces) return
      return this.workspaces.filter(w => w.id !== this.workspaceId)
    }
  },
  methods: {
    ...mapMutations([
      'setSidebar'
    ]),
    async changeWorkspace (workspaceId) {
      this.$router.push({
        name: 'Workspace',
        params: {
          workspaceId
        }
      })

      this.$router.go()
    }
  }
}
